export default {
	namespaced: true,

	state: {
		transactions: [],
		
		getTransactionsApiStatus: 'idle',
	},

	actions: {},

	mutations: {
		setTransactions_mut(state, payload) {
			state.transactions = payload
		},

		setGetTransactionsApiStatus_mut(state, status) {
			state.getTransactionsApiStatus = status
		}
	},

	getters: {}
}